var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFinger(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 123 122",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{mix-blend-mode:screen;}.cls-3{fill:#ccc;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "FinGeR PrRnT") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M115.49,86.36a2.92,2.92,0,0,0,2.68-1.75A60.16,60.16,0,0,0,123,60.9a2.91,2.91,0,0,0-5.81,0,54.41,54.41,0,0,1-4.37,21.47,2.89,2.89,0,0,0,2.67,4Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M9.29,93.12a2.93,2.93,0,0,0,1.23-.27A2.86,2.86,0,0,0,11.92,89,54.43,54.43,0,0,1,7.07,72.51a2.9,2.9,0,0,0-5.76.72A60.48,60.48,0,0,0,6.66,91.47,2.91,2.91,0,0,0,9.29,93.12Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M2.9,63.78A2.89,2.89,0,0,0,5.81,60.9a55.07,55.07,0,0,1,34-50.82,2.87,2.87,0,0,0,1.55-3.77,2.92,2.92,0,0,0-3.81-1.52A60.79,60.79,0,0,0,0,60.9,2.89,2.89,0,0,0,2.9,63.78Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M116.86,44.7a2.89,2.89,0,0,0,2.74-3.82A61.52,61.52,0,0,0,61.5,0a2.89,2.89,0,0,0-2.9,2.88,2.89,2.89,0,0,0,2.9,2.87,55.72,55.72,0,0,1,52.62,37A2.89,2.89,0,0,0,116.86,44.7Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M108,69.43a2.89,2.89,0,0,0,2.88-2.52,48.13,48.13,0,0,0,.37-6A49.41,49.41,0,0,0,86.51,18.27a2.92,2.92,0,0,0-4,1,2.85,2.85,0,0,0,1,3.93A43.64,43.64,0,0,1,105.47,60.9a44.66,44.66,0,0,1-.32,5.31,2.89,2.89,0,0,0,2.53,3.21Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M32.69,27.15a2.9,2.9,0,0,0,1.79-.6,43.76,43.76,0,0,1,27-9.19,44.92,44.92,0,0,1,6.36.45,2.88,2.88,0,1,0,.83-5.69,50.6,50.6,0,0,0-7.19-.51A49.57,49.57,0,0,0,30.91,22a2.86,2.86,0,0,0-.51,4A2.91,2.91,0,0,0,32.69,27.15Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M30.67,113.13a2.88,2.88,0,0,0,2.25-4.7C17.83,90.21,10.59,58.6,24.58,37.24a2.86,2.86,0,0,0-.86-4,2.92,2.92,0,0,0-4,.85C12.56,45,9.82,59.33,12,74.4a78.08,78.08,0,0,0,16.44,37.68A2.91,2.91,0,0,0,30.67,113.13Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M58.5,81.25a2.89,2.89,0,0,0,2.9-2.76,71.69,71.69,0,0,1,2.37-15.95,2.9,2.9,0,0,0-5.61-1.49A76.61,76.61,0,0,0,55.6,78.27a2.88,2.88,0,0,0,2.79,3Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M65.24,121.8a2.91,2.91,0,0,0,1.08-.2,2.88,2.88,0,0,0,1.62-3.74,98.54,98.54,0,0,1-7-29.57,2.9,2.9,0,0,0-5.79.41A104.27,104.27,0,0,0,62.55,120,2.89,2.89,0,0,0,65.24,121.8Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M107.35,99.91a3.21,3.21,0,0,0,.8-.11,2.88,2.88,0,0,0,2-3.56,43.91,43.91,0,0,1-1.3-17.56,2.9,2.9,0,0,0-5.76-.7,49.76,49.76,0,0,0,1.48,19.84A2.89,2.89,0,0,0,107.35,99.91Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M26,63.78A2.9,2.9,0,0,0,28.9,60.9,32.24,32.24,0,0,1,43.08,34.25a2.85,2.85,0,0,0,.75-4,2.92,2.92,0,0,0-4-.75A38,38,0,0,0,23.09,60.9,2.89,2.89,0,0,0,26,63.78Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M97,63.78a2.89,2.89,0,0,0,2.9-2.88,38.27,38.27,0,0,0-38.41-38c-1.31,0-2.64.07-3.94.2a2.88,2.88,0,1,0,.59,5.72c1.1-.11,2.23-.17,3.35-.17A32.49,32.49,0,0,1,94.11,60.9,2.89,2.89,0,0,0,97,63.78Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M97.92,109.23a2.73,2.73,0,0,0,1-.18,2.85,2.85,0,0,0,1.7-3.7,55.42,55.42,0,0,1-2-32.49,2.87,2.87,0,0,0-2.15-3.46A2.9,2.9,0,0,0,93,71.52a61.12,61.12,0,0,0,2.22,35.85A2.89,2.89,0,0,0,97.92,109.23Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M53.79,122a2.91,2.91,0,0,0,2.39-1.25,2.86,2.86,0,0,0-.75-4A61.31,61.31,0,0,1,29,73.76a2.9,2.9,0,0,0-5.75.77,67,67,0,0,0,28.91,47A3,3,0,0,0,53.79,122Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M82.39,53a2.82,2.82,0,0,0,1.34-.33A2.85,2.85,0,0,0,85,48.8,26.6,26.6,0,0,0,43.7,41.53a2.86,2.86,0,0,0-.2,4.06,2.92,2.92,0,0,0,4.1.19,20.78,20.78,0,0,1,32.21,5.67A2.9,2.9,0,0,0,82.39,53Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M81.35,91.55a2.89,2.89,0,0,0,2.9-2.87A90.84,90.84,0,0,1,87.6,64.4,2.9,2.9,0,0,0,82,62.86a96.89,96.89,0,0,0-3.56,25.81,2.9,2.9,0,0,0,2.9,2.88Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M86.86,116A2.89,2.89,0,0,0,89.5,112a51.27,51.27,0,0,1-4-13,2.9,2.9,0,0,0-5.73.93,56.55,56.55,0,0,0,4.43,14.46A2.9,2.9,0,0,0,86.86,116Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M35.48,78.67h.19a2.88,2.88,0,0,0,2.71-3,49.56,49.56,0,0,1,2.73-19.76,2.86,2.86,0,0,0-1.78-3.66A2.91,2.91,0,0,0,35.63,54a55.17,55.17,0,0,0-3,22A2.88,2.88,0,0,0,35.48,78.67Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M76.63,119.85a2.89,2.89,0,0,0,2.65-4,72.52,72.52,0,0,1-3.45-9.37,2.92,2.92,0,0,0-3.6-2,2.87,2.87,0,0,0-2,3.56A77.54,77.54,0,0,0,74,118.14,2.9,2.9,0,0,0,76.63,119.85Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M71.14,101.12a2.09,2.09,0,0,0,.43,0A2.87,2.87,0,0,0,74,97.81a63.22,63.22,0,0,1-.59-13.69,64.92,64.92,0,0,1,.75-6.53,2.9,2.9,0,0,0-5.73-.94,70.31,70.31,0,0,0-.82,7.11,69.4,69.4,0,0,0,.65,14.91A2.89,2.89,0,0,0,71.14,101.12Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M45.65,82.33a2.88,2.88,0,0,0,2.9-2.87c0-9.64,2.71-27.87,13-27.87a9.36,9.36,0,0,1,9.4,9.31c0,.17,0,.35,0,.52a2.9,2.9,0,0,0,5.8.32c0-.27,0-.56,0-.84A15.15,15.15,0,0,0,61.5,45.84C47.66,45.84,42.75,64,42.75,79.46A2.88,2.88,0,0,0,45.65,82.33Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M51.19,108.22a3,3,0,0,0,1.18-.25,2.88,2.88,0,0,0,1.47-3.8,59.89,59.89,0,0,1-4.56-15.33,2.9,2.9,0,0,0-5.74.88,65.74,65.74,0,0,0,5,16.79A2.9,2.9,0,0,0,51.19,108.22Z",
    transform: "translate(0 0)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinger);
export default __webpack_public_path__ + "static/media/finger.7993a0cd073b1c0a2157ffc46f5eae4c.svg";
export { ForwardRef as ReactComponent };